// Display labels for the canonical (English) job values stored in the DB.
const LABELS = {
  work_mode: {
    Remote: { en: "Remote", fr: "Télétravail" },
    Hybrid: { en: "Hybrid", fr: "Hybride" },
    Onsite: { en: "On-site", fr: "Sur site" },
  },
  time_type: {
    "Full-time": { en: "Full-time", fr: "Temps plein" },
    "Part-time": { en: "Part-time", fr: "Temps partiel" },
  },
  contract_type: {
    Permanent: { en: "Permanent", fr: "CDI" },
    "Fixed-term": { en: "Fixed-term", fr: "CDD" },
    Mission: { en: "Mission", fr: "Mission" },
    Freelance: { en: "Freelance", fr: "Freelance" },
    Internship: { en: "Internship", fr: "Stage" },
    Apprenticeship: { en: "Apprenticeship", fr: "Alternance" },
  },
  seniority: {
    Junior: { en: "Junior", fr: "Junior" },
    Mid: { en: "Mid-level", fr: "Confirmé" },
    Senior: { en: "Senior", fr: "Senior" },
    Director: { en: "Director", fr: "Directeur" },
    "VP / C-level": { en: "VP / C-level", fr: "VP / Direction générale" },
  },
  salary_range: {
    Disclosed: { en: "Disclosed", fr: "Communiqué" },
    Unknown: { en: "Not disclosed", fr: "Non communiqué" },
  },
  country: {
    France: { en: "France", fr: "France" },
    UK: { en: "UK", fr: "Royaume-Uni" },
    Germany: { en: "Germany", fr: "Allemagne" },
    Spain: { en: "Spain", fr: "Espagne" },
    Italy: { en: "Italy", fr: "Italie" },
    Netherlands: { en: "Netherlands", fr: "Pays-Bas" },
    Belgium: { en: "Belgium", fr: "Belgique" },
    Denmark: { en: "Denmark", fr: "Danemark" },
    Sweden: { en: "Sweden", fr: "Suède" },
    Switzerland: { en: "Switzerland", fr: "Suisse" },
    USA: { en: "USA", fr: "États-Unis" },
    Canada: { en: "Canada", fr: "Canada" },
  },
};

export const jobLabel = (field, value, lang = "en") => LABELS[field]?.[value]?.[lang] || value || "";

export const jobOptions = (field, lang = "en") =>
  Object.keys(LABELS[field]).map((value) => ({ value, label: jobLabel(field, value, lang) }));

export const hasSalary = (v) => !!v && v !== "Unknown";

// Badges for the values actually set on the job, in display order.
export const jobBadges = (item, lang = "en") =>
  ["time_type", "contract_type", "seniority"]
    .filter((f) => item?.[f])
    .map((f) => ({ field: f, label: jobLabel(f, item[f], lang) }));
